export default {
  setChats(state, payload) {
    state.chats = payload
  },
}
